














import { Component, Vue } from 'vue-property-decorator';
import StNotification from '@/components/basic/StNotification.vue';

@Component({
  components: {StNotification},
})
export default class App extends Vue {
  private default_layout: string = 'default';

  windowWidth: number = window.innerWidth;



  get layout() {
    return (this.$route.meta.layout || this.default_layout) + '-layout';
  }
}
